import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f1f91d1e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "ballLossSet"
};
const _hoisted_2 = {
  class: "ball"
};
const _hoisted_3 = {
  class: "ball-position"
};
const _hoisted_4 = {
  class: "fast-set-row"
};
const _hoisted_5 = {
  class: "fast-set-item"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("快速设置");

const _hoisted_7 = {
  class: "sub"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存设置");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_el_table = _resolveComponent("el-table");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
    data: $data.ball_list,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row"
  }, {
    append: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      size: "small",
      icon: "el-icon-check",
      class: "fast-btn",
      onClick: $options.fast_set_col
    }, {
      default: _withCtx(() => [_hoisted_6]),
      _: 1
    }, 8, ["onClick"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fast, (item, key) => {
      return _openBlock(), _createElementBlock("div", {
        class: "fast-set-item",
        key: key
      }, [_createVNode(_component_el_input, {
        modelValue: $data.fast[key],
        "onUpdate:modelValue": $event => $data.fast[key] = $event,
        size: "small",
        placeholder: "快速设置",
        class: "fast-input",
        disabled: (key === 'low_d_rate' || _ctx.$store.state.userinfo.group_id != 1) && key !== 'lower' && key !== 'added'
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]);
    }), 128))])]),
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      prop: "ball",
      label: "球号",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.position), 1), _createElementVNode("span", null, _toDisplayString(scope.row.ball), 1)])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "high_rate",
      label: "赔率上限",
      align: "center"
    }), _createVNode(_component_el_table_column, {
      prop: "play_rate",
      label: "开盘赔率（A盘）",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.play_rate,
        "onUpdate:modelValue": $event => scope.row.play_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "low_rate",
      label: "A盘下限",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.low_rate,
        "onUpdate:modelValue": $event => scope.row.low_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "b_rate",
      label: "B盘赔率（降）",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.b_rate,
        "onUpdate:modelValue": $event => scope.row.b_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "c_rate",
      label: "C盘赔率（降）",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.c_rate,
        "onUpdate:modelValue": $event => scope.row.c_rate = $event,
        disabled: _ctx.$store.state.userinfo.group_id > 2
      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "added",
      label: "自动降赔率额度",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.added,
        "onUpdate:modelValue": $event => scope.row.added = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "lower",
      label: "每次降赔率",
      align: "center"
    }, {
      default: _withCtx(scope => [_createVNode(_component_el_input, {
        size: "small",
        modelValue: scope.row.lower,
        "onUpdate:modelValue": $event => scope.row.lower = $event
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
    size: "small",
    type: "info",
    onClick: $options.reset
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }, 8, ["onClick"]), _createVNode(_component_el_button, {
    size: "small",
    type: "primary",
    onClick: $options.sub_set
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }, 8, ["onClick"])])]);
}